const routineSampleRate = 0.1
const alwaysRecordedEvents = new Set(["map_error"])

export function recordCostEvent(eventType, properties = {}) {
  const alreadySampled = properties.sample_rate !== undefined
  if (!alwaysRecordedEvents.has(eventType) && !alreadySampled && Math.random() >= routineSampleRate) return

  const token = document.querySelector('meta[name="csrf-token"]')?.content
  const sampledProperties = alreadySampled || alwaysRecordedEvents.has(eventType)
    ? properties
    : { ...properties, sample_rate: routineSampleRate }

  fetch("/cost-telemetry", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-CSRF-Token": token || ""
    },
    body: JSON.stringify({ event_type: eventType, properties: sampledProperties }),
    credentials: "same-origin",
    keepalive: true
  }).catch(() => {})
}
